import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ProductComponent from "../components/product/product-comp";
import { useEffect } from "react";

const Product = () => {
    const { t } = useTranslation();  
    const { id } = useParams();

    useEffect(() => {
        setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 100);
    }, [])

    return (
        <div className="product-page">
            <h1 className="page-h1">{t('pages.product')}</h1>
            <div className="content-wrapper">
                <ProductComponent productId={id} />
            </div>
        </div>
    )
}

export default Product;